import createAxios from "@features/share/api/Caxios";
import { API_VERSION, BUILDER_API_URL, KEY_TOKEN, NEXT_PUBLIC_LDP_API_URL, NEXT_PUBLIC_STORE_API_URL,  } from '../configs/system';
import { hasCookie } from "../helper/system";
import Cookies from "js-cookie";
import ProfileEndUserInterface from "../models/EndUserInterface";
import ProfileInterface from "../models/ProfileInterface";

const baseApiUrl = NEXT_PUBLIC_LDP_API_URL
const baseApiMinistoreUrl = NEXT_PUBLIC_STORE_API_URL
const builderApiUrl = BUILDER_API_URL

const Caxios = createAxios()

const API_URL = {
  get_profile_by_domain: `${baseApiUrl}/api/${API_VERSION}/end-user/get-seller-profile-by-domain`,
  get_end_user_profile: `${baseApiMinistoreUrl}/api/customer/profile`,
  get_site_setting: `${builderApiUrl}/site-setting/main`,
  get_website_config: `${builderApiUrl}/api/enduser/website-config`
}

const accountApi = {
  getSellerProfile: async (domain: string): Promise<ProfileInterface | null> => {
    try {
      const res = await Caxios.get(API_URL.get_profile_by_domain, {
        params: { domain }
      });
      return res.data
    } catch (e) {
      return null
    }
  },
  getWebsiteConfig : async (user_id: string): Promise<any | null> => {
    try {
      const res = await Caxios.get(API_URL.get_website_config,{
        params: {
          user_id
        }
      });
      return res.data
    } catch (e) {
      return null
    }
  },
  getEnduserProfile : async (): Promise<ProfileEndUserInterface | null> => {
    try {
      const keyToken = Cookies.get(KEY_TOKEN);
      let tokenUser = ''
      if (keyToken) {
        const customerData = JSON.parse(keyToken);
        tokenUser = customerData.access_token;
      }
      const res = await Caxios.get(API_URL.get_end_user_profile, {
        headers: {
          "Authorization": `Bearer ${tokenUser}`
        },
      });
      return res.data
    } catch (e) {
      return null
    }
  },
  getSiteSetting: async (user_id) => {
    try {
      const res = await Caxios.get(API_URL.get_site_setting, {
        params: { user_id }
      });
      return res.data.display_setting
    } catch(e) {
      return null
    }
  }
}

export default accountApi